/* Taze Gurme UI polish — product detail structure v3. */
(function () {
  var PRODUCT_SELECTOR = '.content-for-layout[data-template^="product"]';

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/\u00a0/g, ' ')
      .replace(/[’']/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanLabel(value) {
    return normalize(value)
      .replace(/^[\s:：\-–—]+|[\s:：\-–—]+$/g, '')
      .trim();
  }

  function getProductDetails(scope) {
    var root = scope && scope.querySelector ? scope : document;
    return root.querySelector('.product-details > .group-block') || document.querySelector('.product-details > .group-block');
  }

  function directChild(container, element) {
    if (!container || !element) return null;
    var current = element;
    while (current.parentElement && current.parentElement !== container) {
      current = current.parentElement;
    }
    return current.parentElement === container ? current : null;
  }

  function findDescription(details) {
    var candidates = Array.prototype.slice.call(details.querySelectorAll('.text-block.rte')).filter(function (element) {
      if (element.closest('.tg-product-info-stack')) return false;
      return element.textContent.replace(/\s+/g, ' ').trim().length >= 80;
    });

    if (!candidates.length) return null;

    candidates.sort(function (a, b) {
      return b.textContent.length - a.textContent.length;
    });

    return candidates[0];
  }

  function moveDescriptionAfterPurchase(details, description) {
    var descriptionRoot = directChild(details, description);
    var buyButtons = details.querySelector('.buy-buttons-block');
    var buyRoot = directChild(details, buyButtons);

    if (!descriptionRoot) return null;

    descriptionRoot.classList.add('tg-product-description-block');

    if (buyRoot && descriptionRoot !== buyRoot) {
      if (buyRoot.nextSibling) {
        details.insertBefore(descriptionRoot, buyRoot.nextSibling);
      } else {
        details.appendChild(descriptionRoot);
      }
    }

    return descriptionRoot;
  }

  function titlesMatch(headingText, titleText) {
    var heading = cleanLabel(headingText).replace(/[|]/g, '-');
    var title = cleanLabel(titleText).replace(/[|]/g, '-');

    if (!heading || !title) return false;
    return heading === title || heading.indexOf(title + ' ') === 0 || heading.indexOf(title + ' -') === 0 || heading.indexOf(title + ' –') === 0 || heading.indexOf(title + ' —') === 0;
  }

  function removeDuplicateDescriptionTitle(details, description) {
    var productTitleElement = details.querySelector('h1');
    if (!productTitleElement) return;

    var firstHeading = description.querySelector('h1, h2, h3');
    if (!firstHeading) return;

    if (titlesMatch(firstHeading.textContent, productTitleElement.textContent)) {
      firstHeading.remove();
    }
  }

  function isHeading(element) {
    return Boolean(element && /^H[1-6]$/.test(element.tagName));
  }

  function isInlineBoldLabel(element) {
    if (!element) return false;
    if (/^(STRONG|B)$/.test(element.tagName)) return true;
    if (element.tagName !== 'SPAN') return false;

    var weight = String((element.style && element.style.fontWeight) || '').trim().toLowerCase();
    if (weight === 'bold' || weight === 'bolder') return true;

    var numericWeight = parseInt(weight, 10);
    return Number.isFinite(numericWeight) && numericWeight >= 600;
  }

  function getInlineLabelElement(element) {
    if (!element || !/^(P|DIV|LI)$/.test(element.tagName)) return null;
    var first = element.firstElementChild;
    if (!isInlineBoldLabel(first)) return null;
    return first;
  }

  function classifyLabel(value) {
    var label = cleanLabel(value);

    if (/^(içindekiler|icerik|ingredients)\b/.test(label)) return 'ingredients';
    if (/^(besin değerleri|besin değeri|besin içeriği|besin bilgileri|beslenme değerleri|nutrition)\b/.test(label)) return 'nutrition';
    if (/^(nasıl kullanılır|nasil kullanilir|kullanım önerileri|kullanim onerileri|kullanım|kullanim|hazırlama|hazirlanisi|hazırlanışı|servis önerisi)\b/.test(label)) return 'usage';
    if (/^(alerjen bilgisi|alerjen uyarısı|alerjen uyarisi|alerjenler|alerjen|allergen|allergens)\b/.test(label)) return 'allergen';
    if (/^(saklama koşulları|saklama kosullari|saklama önerisi|saklama onerisi|saklama)\b/.test(label)) return 'storage';
    if (/^(menşei|mensei|menşe|mense|üretim yeri|uretim yeri)\b/.test(label)) return 'origin';

    return null;
  }

  function getMarkerType(element) {
    if (!element) return null;
    if (isHeading(element)) return classifyLabel(element.textContent);

    var inlineLabel = getInlineLabelElement(element);
    return inlineLabel ? classifyLabel(inlineLabel.textContent) : null;
  }

  function isSectionBoundary(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    if (isHeading(node)) return true;
    return Boolean(getMarkerType(node));
  }

  function stripInlineLabel(element, type) {
    var clone = element.cloneNode(true);
    var label = getInlineLabelElement(clone);
    if (!label || classifyLabel(label.textContent) !== type) return clone;

    label.remove();

    while (clone.firstChild && clone.firstChild.nodeType === Node.TEXT_NODE) {
      clone.firstChild.textContent = clone.firstChild.textContent.replace(/^[\s:：\-–—]+/, '');
      if (clone.firstChild.textContent) break;
      clone.firstChild.remove();
    }

    return clone;
  }

  function fragmentHasContent(fragment) {
    var wrapper = document.createElement('div');
    wrapper.appendChild(fragment.cloneNode(true));
    if (wrapper.textContent.replace(/\s+/g, ' ').trim()) return true;
    return Boolean(wrapper.querySelector('table, ul, ol, img, video'));
  }

  function extractMarker(marker, type) {
    var fragment = document.createDocumentFragment();
    var markerText = marker.textContent.replace(/\s+/g, ' ').trim();
    var inlineLabel = getInlineLabelElement(marker);

    if (inlineLabel) {
      var stripped = stripInlineLabel(marker, type);
      if (stripped.textContent.replace(/\s+/g, ' ').trim() || stripped.querySelector('table, ul, ol, img, video')) {
        fragment.appendChild(stripped);
      }
    }

    var next = marker.nextSibling;
    marker.remove();

    while (next) {
      var current = next;
      next = current.nextSibling;

      if (current.nodeType === Node.ELEMENT_NODE && isSectionBoundary(current)) {
        break;
      }

      fragment.appendChild(current);
    }

    return {
      type: type,
      markerText: markerText,
      fragment: fragment
    };
  }

  function collectStructuredContent(description) {
    var buckets = {
      ingredients: [],
      nutrition: [],
      usage: [],
      allergen: [],
      storage: [],
      origin: []
    };

    var candidates = Array.prototype.slice.call(description.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div'));
    var markers = candidates.map(function (element) {
      return { element: element, type: getMarkerType(element) };
    }).filter(function (entry) {
      return Boolean(entry.type);
    });

    markers.forEach(function (entry) {
      if (!entry.element.isConnected || !description.contains(entry.element)) return;
      var extracted = extractMarker(entry.element, entry.type);
      if (fragmentHasContent(extracted.fragment)) {
        buckets[entry.type].push(extracted);
      }
    });

    return buckets;
  }

  function appendFragments(entries) {
    var fragment = document.createDocumentFragment();
    entries.forEach(function (entry) {
      fragment.appendChild(entry.fragment);
    });
    return fragment;
  }

  function createToggle() {
    var toggle = document.createElement('span');
    toggle.className = 'tg-product-info-panel__toggle';
    toggle.setAttribute('aria-hidden', 'true');
    return toggle;
  }

  function createSummary(titleText) {
    var summary = document.createElement('summary');
    summary.className = 'tg-product-info-panel__summary';

    var title = document.createElement('span');
    title.className = 'tg-product-info-panel__title';
    title.textContent = titleText;

    summary.appendChild(title);
    summary.appendChild(createToggle());
    return summary;
  }

  function makeColumn(labelText, className, fragment) {
    var column = document.createElement('div');
    column.className = 'tg-product-info-panel__column ' + className;

    var label = document.createElement('div');
    label.className = 'tg-product-info-panel__column-label';
    label.textContent = labelText;
    column.appendChild(label);
    column.appendChild(fragment);

    return column;
  }

  function cleanImportedTable(column) {
    Array.prototype.slice.call(column.querySelectorAll('table')).forEach(function (table) {
      table.removeAttribute('border');
      table.removeAttribute('style');
      Array.prototype.slice.call(table.querySelectorAll('[style]')).forEach(function (element) {
        element.removeAttribute('style');
      });
    });
  }

  function enhanceNutritionList(column) {
    cleanImportedTable(column);
    if (column.querySelector('table')) return;

    var list = column.querySelector('ul, ol');
    if (!list) return;

    var items = Array.prototype.slice.call(list.children).filter(function (item) {
      return item.tagName === 'LI';
    });
    if (!items.length) return;

    var rows = document.createElement('div');
    rows.className = 'tg-nutrition-rows';
    var converted = 0;

    items.forEach(function (item) {
      var labelElement = item.querySelector('strong, b');
      if (!labelElement) return;

      var labelText = labelElement.textContent.replace(/[:：]+\s*$/, '').trim();
      if (!labelText) return;

      var valueClone = item.cloneNode(true);
      var valueLabel = valueClone.querySelector('strong, b');
      if (valueLabel) valueLabel.remove();

      var valueHtml = valueClone.innerHTML.replace(/^[\s:：\-–—]+/, '').trim();
      var row = document.createElement('div');
      row.className = 'tg-nutrition-row';

      var term = document.createElement('div');
      term.className = 'tg-nutrition-row__term';
      term.textContent = labelText;

      var value = document.createElement('div');
      value.className = 'tg-nutrition-row__value';
      value.innerHTML = valueHtml;

      row.appendChild(term);
      row.appendChild(value);
      rows.appendChild(row);
      converted += 1;
    });

    if (converted === items.length) {
      list.replaceWith(rows);
    }
  }

  function createPrimaryPanel(buckets) {
    var hasIngredients = buckets.ingredients.length > 0;
    var hasNutrition = buckets.nutrition.length > 0;
    if (!hasIngredients && !hasNutrition) return null;

    var panel = document.createElement('details');
    panel.className = 'tg-product-info-panel tg-product-info-panel--primary';
    panel.open = true;
    panel.appendChild(createSummary('İçindekiler & Besin Değerleri'));

    var content = document.createElement('div');
    content.className = 'tg-product-info-panel__content';

    if (hasIngredients) {
      content.appendChild(makeColumn('İçindekiler', 'tg-product-info-panel__ingredients', appendFragments(buckets.ingredients)));
    }

    if (hasNutrition) {
      var nutritionLabel = buckets.nutrition[0].markerText || 'Besin Değerleri';
      var nutritionColumn = makeColumn(nutritionLabel, 'tg-product-info-panel__nutrition', appendFragments(buckets.nutrition));
      enhanceNutritionList(nutritionColumn);
      content.appendChild(nutritionColumn);
    }

    if (!(hasIngredients && hasNutrition)) {
      content.classList.add('is-single');
    }

    panel.appendChild(content);
    return panel;
  }

  function createSimplePanel(titleText, entries, kind) {
    if (!entries.length) return null;

    var panel = document.createElement('details');
    panel.className = 'tg-product-info-panel tg-product-info-panel--secondary';
    panel.dataset.tgInfoKind = kind;
    panel.appendChild(createSummary(titleText));

    var content = document.createElement('div');
    content.className = 'tg-product-info-panel__secondary-content';
    content.appendChild(appendFragments(entries));
    panel.appendChild(content);

    return panel;
  }

  function renderInlineMarkdownStrong(container) {
    if (!container) return;

    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var current;

    while ((current = walker.nextNode())) {
      if (current.nodeValue && /\*\*[^*\n]+\*\*/.test(current.nodeValue)) {
        nodes.push(current);
      }
    }

    nodes.forEach(function (textNode) {
      var parts = textNode.nodeValue.split(/(\*\*[^*\n]+\*\*)/g);
      if (parts.length < 2) return;

      var fragment = document.createDocumentFragment();
      parts.forEach(function (part) {
        var match = part.match(/^\*\*([^*\n]+)\*\*$/);
        if (match) {
          var strong = document.createElement('strong');
          strong.textContent = match[1];
          fragment.appendChild(strong);
        } else if (part) {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      textNode.replaceWith(fragment);
    });
  }

  function buildInfoStack(description, buckets) {
    var panels = [
      createSimplePanel('Kullanım & Hazırlama', buckets.usage, 'usage'),
      createPrimaryPanel(buckets),
      createSimplePanel('Alerjen Bilgisi', buckets.allergen, 'allergen'),
      createSimplePanel('Saklama Koşulları', buckets.storage, 'storage'),
      createSimplePanel('Menşei', buckets.origin, 'origin')
    ].filter(Boolean);

    if (!panels.length) return;

    var stack = document.createElement('div');
    stack.className = 'tg-product-info-stack';
    panels.forEach(function (panel) {
      stack.appendChild(panel);
    });

    description.insertBefore(stack, description.firstChild);
    renderInlineMarkdownStrong(stack);
  }

  function cleanEmptyContainers(description) {
    var containers = Array.prototype.slice.call(description.querySelectorAll('div, p')).reverse();
    containers.forEach(function (element) {
      if (element.closest('.tg-product-info-stack')) return;
      var text = element.textContent.replace(/\s+/g, ' ').trim();
      var rich = element.querySelector('img, video, table, ul, ol, blockquote');
      if (!text && !rich && element.children.length === 0) {
        element.remove();
      }
    });
  }

  function enhanceProduct(scope) {
    if (!document.querySelector(PRODUCT_SELECTOR)) return;

    var details = getProductDetails(scope);
    if (!details) return;

    var description = findDescription(details);
    if (!description || description.dataset.tgProductEnhanced === 'v3') return;
    description.dataset.tgProductEnhanced = 'v3';

    moveDescriptionAfterPurchase(details, description);
    removeDuplicateDescriptionTitle(details, description);

    var buckets = collectStructuredContent(description);
    cleanEmptyContainers(description);
    buildInfoStack(description, buckets);
  }

  function init() {
    enhanceProduct(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceProduct(event.target);
  });
})();
